import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdsService } from '../../services/ads.service';
import { NgFor, NgIf } from '@angular/common';
import { AdsModel } from '../../models/ads.modal';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MkmService } from '../../services/mkm.service';
import { TzadikimService } from '../../services/tz.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import swal from 'sweetalert2';
@Component({
  selector: 'app-advertisement',
  standalone: true,
  imports: [
    NgFor,
    FormsModule,
    NgIf,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatDatepickerModule,
  ],
  providers: [
    AdsService,
    MkmService,
    TzadikimService,
    FormBuilder,
    provideNativeDateAdapter(),
  ],
  templateUrl: './advertisement.component.html',
  styleUrl: './advertisement.component.css',
})
export class AdvertisementComponent implements OnInit {
  existingImageUrl: any;
  filteredOptions: any[] = [];
  today = new Date();
  adsData;
  selectedmkmId;
  searchValue = '';
  mkmsList = [];
  tzadikimList = [];
  adsForm: FormGroup;
  createAds!: AdsModel;
  showAdUrlInput: boolean = false;
  showMkmInput: boolean = false;
  showTzadikimInput: boolean = false;
  isEditMode: boolean = false;
  editAdID: number | null = null;
  fileID: number | null = null;
  fileID2: number | null = null;
  showSecondUpload: boolean = false;
  fileImageUrl: string;
  fileImageUrl2: string;
  showFirstUpload = true
  @ViewChild('closeBtn') closeBtn: ElementRef;
  constructor(
    private adsService: AdsService,
    private mkmService: MkmService,
    private tzadikimService: TzadikimService,
    private formBuilder: FormBuilder
  ) { }
  ngOnInit(): void {
    this.createAds = new AdsModel();
    this.adsForm = this.formBuilder.group({
      adTitle: [''],
      mkmId: [''],
      adUrl: [''],
      File: {
        fileContent: '',
        fileType: '',
        fileName: '',
      },
      File2: {
        fileContent: '',
        fileType: '',
        fileName: '',
      },
      adType: [''],
      startDate: [''],
      endDate: [''],
      type: [''],
    });

    this.getAllAds();

    this.mkmService.getAllMkms().subscribe((data) => {
      this.mkmsList = data;
    });
    this.tzadikimService.getTzadikim().subscribe((data) => {
      this.tzadikimList = data;
    });
  }
  getAllAds() {
    this.adsService.getAds().subscribe((ads) => {
      this.adsData = ads;
    });
  }

  displayAd(id: number, display: boolean) {
    const actionText = display ? 'Restore' : 'Delete';
    swal.fire({
      title: `Are you sure you want to ${actionText} this ad?`,
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes, ${actionText} it!`
    }).then((result) => {
      if (result.isConfirmed) {
        let data = {
          id: id,
          display: display,
        };
        this.adsService.displayAd(data).subscribe((success) => {
          console.log(success, 'Display Succesffuly ');
          this.getAllAds();
          swal.fire(
            `${actionText}d!`,
            `The Ad has been ${actionText}d.`,
            'success'
          );
        });
      }
    });
  }

  publishAd(id: number, value: boolean) {
    if (value) {
      var isPublish = 'UnPublish';
    } else {
      isPublish = 'Publish';
    }
    swal
      .fire({
        title: `Are you sure you want to ${isPublish}?`,
        text: '',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: `Yes, ${isPublish} it!`,
        cancelButtonText: 'Cancel',
      })
      .then((result) => {
        if (result.isConfirmed) {
          // Call the publishAd if confirmed

          let data = {
            id: id,
            published: !value,
          };
          this.adsService.publishedAd(data).subscribe((success) => {
            console.log(success, 'Published Succesffuly ');
            this.getAllAds();
          });
          // Show success message
          swal.fire(
            `${isPublish}ed!`,
            `The Ad has been ${isPublish}ed.`,
            'success'
          );
        }
      });
  }
  displayFn = (value: any): string => {
    if (!value) return '';
    if (this.adsForm.value.adType === '1') {
      const mkm = this.filteredOptions.find((opt) => opt.id === value);
      if (mkm) return `${mkm.mkmTitle}`;
    }
    if (this.adsForm.value.adType === '2') {
      const tzadik = this.filteredOptions.find((opt) => opt.mkmId === value);
      if (tzadik) return `${tzadik.subTitle}`;
    }
    return '';
  };

  removeSecondImage() {
    this.showSecondUpload = false;
    this.adsForm.patchValue({
      File2: { fileContent: '', fileType: '', fileName: '' },
    });
  }
  editAd(data: any) {
    console.log('Edit Ad Data:', data, this.adsForm.value);
    this.isEditMode = true;
    this.editAdID = data.id;

    this.fileID = data.fileId || null;
    this.fileID2 = data.fileId2 || null;

    this.fileImageUrl = this.fileID ? this.getFileUrl(this.fileID) : null;
    this.fileImageUrl2 = this.fileID2 ? this.getFileUrl(this.fileID2) : null;

    const adTypeMap: any = {
      Mkm: '1',
      Tzadikim: '2',
      OutsideLink: '3',
      Image: '4',
    };
    const normalizedAdType = adTypeMap[data.adType] || data.adType;

    this.adsForm.patchValue({
      adTitle: data.title,
      adType: normalizedAdType,
      type: data.type,
      startDate: data.startDate ? new Date(data.startDate) : '',
      endDate: data.endDate ? new Date(data.endDate) : '',
      mkmId: data.mkmId || '',
      adUrl: data.adUrl || '',

      File: {
        fileContent: '',
        fileType: '',
        fileName: '',
      },
      File2: {
        fileContent: '',
        fileType: '',
        fileName: '',
      },
    });

    if (normalizedAdType === '1') {
      this.showMkmInput = true;
      const selectedMkm = this.mkmsList.find((opt) => opt.id === data.mkmId);
      this.filteredOptions = selectedMkm ? [selectedMkm] : [];
    } else if (normalizedAdType === '2') {
      this.showTzadikimInput = true;
      const selectedTzadik = this.tzadikimList.find(
        (opt) => opt.mkmId === data.mkmId
      );
      this.filteredOptions = selectedTzadik ? [selectedTzadik] : [];
    } else {
      this.filteredOptions = [];
    }

    this.onAdTypeChange({ value: Number(normalizedAdType) });
    console.log('Edit Ad Data: 2', data, this.adsForm.value);
  }

  onchange(event: any) {
    const labelElement = event.target.getAttribute('aria-label');
    this.searchValue = this.adsForm.value.mkmId.toLowerCase();

    if (labelElement === 'places') {
      if (this.searchValue === '') {
        this.filteredOptions = [...this.mkmsList];
      } else {
        this.filteredOptions = this.mkmsList.filter(
          (option) =>
            option.mkmTitle
              .toLowerCase()
              .includes(this.searchValue.toLowerCase()) ||
            option.city.cityY
              .toLowerCase()
              .includes(this.searchValue.toLowerCase())
        );
      }
    } else {
      if (this.searchValue === '') {
        this.filteredOptions = [...this.tzadikimList];
      } else {
        this.filteredOptions = this.tzadikimList.filter((option) =>
          option.subTitle.toLowerCase().includes(this.searchValue.toLowerCase())
        );
      }
    }
  }
  handleOnChange(event: any, fileNumber: number) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      const base64Content = (reader.result as string).split(',')[1] || '';

      const fileData = {
        fileType: file.type || '',
        fileName: file.name || '',
        fileContent: base64Content,
      };

      if (fileNumber === 1) {
        this.adsForm.patchValue({ File: fileData });
      } else if (fileNumber === 2) {
        this.adsForm.patchValue({ File2: fileData });
      }
    };

    reader.readAsDataURL(file);
  }
  private isFileNotEmpty(file: any): boolean {
    return file.fileContent !== '' || file.fileName !== '' || file.fileType !== '';
  }

  submitForm() {
    const adTypeMap: any = {
      '1': 'Mkm',
      '2': 'Tzadikim',
      '3': 'OutsideLink',
      '4': 'Image',
    };

    // const normalizedAdType = adTypeMap[this.adsForm.value.adType];
    // this.adsForm.patchValue({ adType: normalizedAdType });

    //  const updateStartDate = this.adsForm.value.startDate?.toLocaleDateString();
    //   const updateEndDate = this.adsForm.value.endDate?.toLocaleDateString();
    const formValue = this.adsForm.value;
    const formData = {
      ...formValue,
      startDate: formValue.startDate
        ? formValue.startDate?.toLocaleDateString()
        : '',
      endDate: formValue.endDate ? formValue.endDate?.toLocaleDateString() : '',
      adType: adTypeMap[formValue.adType],
      mkmId: formValue.mkmId !== '' ? Number(formValue.mkmId) : null,
    };
    if (this.isEditMode && this.editAdID !== null) {
      formData['id'] = this.editAdID;
      formData['fileId'] = this.fileID;
      formData['fileId2'] = this.fileID2;
      if (
        this.isFileNotEmpty(formValue.File)
      ) {
        formData['fileId'] = null;
      } else {
        formData['File'] = null;
      }
      if (this.isFileNotEmpty(formValue.File2)) {
        formData['fileId2'] = null;
      } else {
        formData['File2'] = null;
      }
      this.adsService.editAds(formData).subscribe({
        next: (success) => {
          this.closeBtn.nativeElement.click();
          this.adsForm.reset();
          console.log('Edit Success:', this.adsForm.value);
          this.getAllAds();
          this.isEditMode = false;
          this.editAdID = null;
        },
        error: (error) => {
          console.error('Edit Error:', error);
          swal.fire(
            'Error',
            'Failed to update the ad. Please try again.',
            'error'
          );
          this.restartFormProcess();
        },
      });
    } else {
      this.adsService.AddAds(formData).subscribe({
        next: (success) => {
          this.closeBtn.nativeElement.click();
          this.adsForm.reset();

          this.getAllAds();
        },
        error: (error) => {
          console.error('Add Error:', error);
          swal.fire(
            'Error',
            'Failed to add the ad. Please try again.',
            'error'
          );
          this.restartFormProcess();
        },
      });
    }
  }
  restartFormProcess() {
    this.isEditMode = false;
    this.editAdID = null;
    this.adsForm.reset();
    this.filteredOptions = [];
    this.showAdUrlInput = false;
    this.showMkmInput = false;
    this.showTzadikimInput = false;
  }
  // onMkmSelected(option: any) {
  //   this.adsForm.get('mkmId')?.setValue(option.mkmTitle);
  // }

  // onTzadikimSelected(option: any) {
  //   this.adsForm.get('mkmId')?.setValue(option.subTitle);
  // }

  onAdTypeChange(event: any) {
    const adType = event.value;
    this.showMkmInput = adType == 1;
    this.showTzadikimInput = adType == 2;
    this.showAdUrlInput = adType == 3;

    if (this.showMkmInput) {
      this.filteredOptions = [...this.mkmsList];
    } else if (this.showTzadikimInput) {
      this.filteredOptions = [...this.tzadikimList];
    }
    if (!this.isEditMode) {
      this.adsForm.get('mkmId')?.setValue('');
    }
  }

  getFileUrl(fileId: number) {
    return `${this.mkmService.baseUrl}/files?id=${fileId}`;
  }
  openAddModal() {
    this.isEditMode = false;
    this.editAdID = null;
    this.adsForm.reset();
    this.fileImageUrl = null;
    this.fileImageUrl2 = null
  }
}
